import Angular from "angular";
import Color from "color-js";

/**
 * https://github.com/brehaut/color-js
 */

let ColorFilterModule = Angular.module('color-filter', []);

ColorFilterModule.filter('color', function () {

    return function (input, method, param) {
        if (!input || !method) {
            return input;
        }

        let color = new Color(input);

        if ("shiftHue" == method) {
            return color.shiftHue(parseInt(param)).toString();
        }

        if ("darkenByAmount" == method) {
            return color.darkenByAmount(parseFloat(param)).toString();
        }

        if ("darkenByRatio" == method) {
            return color.darkenByRatio(parseFloat(param)).toString();
        }

        if ("lightenByAmount" == method) {
            return color.lightenByAmount(parseFloat(param)).toString();
        }

        if ("lightenByRatio" == method) {
            return color.lightenByRatio(parseFloat(param)).toString();
        }

        if ("devalueByAmount" == method) {
            return color.devalueByAmount(parseFloat(param)).toString();
        }

        if ("devalueByRatio" == method) {
            return color.devalueByRatio(parseFloat(param)).toString();
        }

        if ("valueByAmount" == method) {
            return color.valueByAmount(parseFloat(param)).toString();
        }

        if ("valueByRatio" == method) {
            return color.valueByRatio(parseFloat(param)).toString();
        }

        if ("desaturateByAmount" == method) {
            return color.desaturateByAmount(parseFloat(param)).toString();
        }

        if ("desaturateByRatio" == method) {
            return color.desaturateByAmount(parseFloat(param)).toString();
        }

        if ("saturateByAmount" == method) {
            return color.desaturateByAmount(parseFloat(param)).toString();
        }

        if ("saturateByRatio" == method) {
            return color.desaturateByAmount(parseFloat(param)).toString();
        }

        if("blendWhite" == method) {
            return color.blend(new Color('#FFFFFF'), parseFloat(param)).toString();
        }

        return input;
    }

});

export default ColorFilterModule;



// WEBPACK FOOTER //
// ./src/modules/core/filters/color.filter.js